export default __webpack_public_path__ + "static/shirt-9fe0db46a14cfe04b23e7560dd1c16ef.png";